import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { BrandViewModel } from 'projects/StatusTracker/src/app/Models/brand';
import { OrderStatusService } from 'projects/StatusTracker/src/app/Services/orderstatus/order-status.service';
import { NotificationViewComponent } from '../notification-view/notification-view.component';
import { NotificationRequestViewModel}  from 'projects/StatusTracker/src/app/Models/notification-request-view-model';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-view-notification-details',
  templateUrl: './view-notification-details.component.html',
  styleUrls: ['./view-notification-details.component.css']
})
export class ViewNotificationDetailsComponent implements OnInit {
  headerInfo = Object();
  brandList: BrandViewModel[]
  currentLang: string;
  selectedLanguageText: string;
  selectedLanguageFlag: string;
  selectedLangExpireDate = new Date();
  languageModel: any;
  isLanguageFlag: boolean = false;
  licensePlateClass:string;
  notificationPopupOpen: boolean = false;
  notificationList: any =[];
  VehicleBrandLogo: string = '';
  @Input() notificationheader:any;
  notificationRequestModel:NotificationRequestViewModel =
  {
    userId: null,
    isRead: null,
    searchTerm: ""
  };

  constructor(
   private orderService: OrderStatusService,
   private spinner: NgxSpinnerService,
   private cdr: ChangeDetectorRef,
   private modalService: NgbModal,
   private router:Router,
   private translate: TranslateService
  ) { }

  ngOnInit(): void {
     this.GetCustomerNotifications();
  }
  moveBack(){
    this.router.navigateByUrl(`order-status`);
  }
  viewNotification(notification)
  {
    let modelHeadermsg=this.translate.instant("lblNotificationDetails");
    const modalRef = this.modalService.open(NotificationViewComponent, {size: 'lg',centered:true});
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.regNumber = this.notificationheader.numberPlate;
    modalRef.componentInstance.dealer = this.notificationheader.dealerName;
    modalRef.componentInstance.notificationList = notification;
    modalRef.result.then((_result) => { 
      //modal result
    }, (_reason) => {
      if(!(notification.isRead))
      {
          this.markAsRead(notification);
      }
    });
  }
  
  GetCustomerNotifications(){
    if (this.notificationheader) {
      const userId = `${this.notificationheader.orderNumber}|${this.notificationheader.customerGuid}`;
      if (userId) {
        this.notificationRequestModel.userId=userId;
        this.notificationRequestModel.isRead="ALL";
        this.spinner.show();
        this.orderService.getCustomerNotifications(this.notificationRequestModel).subscribe(
          (res)=>{
            if (res?.responseObject){
              res.responseObject.forEach(element => {
                element.date = element.date ? new Date(element.date + 'Z') : null;
              });
              this.notificationList = res.responseObject;
              this.cdr.detectChanges();
            }
          },
          (_error)=>{
            this.spinner.hide();
          },
          ()=>{
            this.spinner.hide();
          },
        );
      }
    }
   
  }
  async markAsRead(notification){
    this.spinner.show();
    if (this.notificationheader) {
      const userId = this.notificationheader.customerGuid;
      if (userId) {
        this.orderService.notificationMarkAsRead(notification.notificationId).subscribe(          
          (response)=>{
            if (response) {
              notification.isRead=true;
            }
          },
          (_error)=>{
            this.spinner.hide();
          },
          ()=>{
            this.spinner.hide();
          },
        );
      }
    }
  }
}


